import { render, staticRenderFns } from "./PushTemplates.vue?vue&type=template&id=27371188&"
import script from "./PushTemplates.vue?vue&type=script&lang=ts&"
export * from "./PushTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports